import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/firestore";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyBuCquSaiYJgDZAXUly3URLkiWw1fmpsTc",
  authDomain: "sarahah-clone.firebaseapp.com",
  databaseURL: "https://sarahah-clone.firebaseio.com",
  projectId: "sarahah-clone",
  storageBucket: "sarahah-clone.appspot.com",
  messagingSenderId: "948553250313",
  appId: "1:948553250313:web:1243f2e2d999d109382ad8",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();
const auth = firebase.auth();
const timeStamp = firebase.firestore.FieldValue.serverTimestamp;
export { firestore, auth, timeStamp };
